import {api} from './api';


export const contactApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendContact: builder.mutation<void, {
      name: string;
      email: string;
      message: string;
    }>({
      query: (body) => ({
        url: "communication/contact/",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useSendContactMutation } = contactApi;